<template>
        <div class="ty w-100 section-spacing ty" style="background-color: var(--white2);">
            <div class="ty form-box-wrapper">
          <div class="ty register-form-box">
            <div class="ty btn-wrapper">
              <button class="ty close-btn" data-bs-dismiss="modal"><img src="../assets/imgs/icon/cross.webp"
                  alt="icon image"></button>
            </div>
            <div class="ty title-wrapper">
              <h2 class="ty title"><span>Start Your <br>
                  Journey</span> with us.</h2>
            </div>
            <div class="ty icon">
              <img src="../assets/imgs/shape/shape-s-55.webp" alt="shape image">
            </div>
            <div class="ty form-wrapper">
              <form action="#" class="ty user-form">
                <div class="ty input-field">
                  <input type="text" placeholder="Type your name">
                </div>
                <div class="ty input-field">
                  <input type="text" placeholder="User name">
                </div>
                <div class="ty input-field">
                  <input type="email" placeholder="Type Email">
                </div>
                <div class="ty input-field">
                  <input type="password" placeholder="Type Password">
                </div>
                <div class="ty input-field">
                  <input type="password" placeholder="Confirm Password">
                </div>
                <div class="ty policy-field">
                  <input type="checkbox" id="d-policy" name="d-policy" value="Boat">
                  <label for="d-policy">I agree to sassly <span><a href="#">Terms of Service.</a></span></label>
                </div>
                <button type="submit" class="ty subscribe-btn wc-btn-primary btn-text-flip"><span
                    data-text="Register">Register</span></button>
              </form>
            </div>
            <div class="ty note">
              <p>Already have an account? <span><a href="javascript:void(0)" data-bs-dismiss="modal"
                    data-bs-toggle="modal" data-bs-target="#staticBackdrop">Login Here!</a></span></p>
            </div>
            <h3 class="ty alternative-title"><span>OR</span></h3>
            <ul class="ty social-links">
              <li><a href="#"><i class="ty fa-brands fa-twitter"></i></a></li>
              <li><a href="#"><i class="ty fa-brands fa-instagram"></i></a></li>
              <li><a href="#"><i class="ty fa-brands fa-linkedin"></i></a></li>
            </ul>
          </div>
        </div>
        </div>
</template>

<script>
export default {
    name: "Bookademo"
}
</script>

<style lang="scss" scoped>
@import "../assets/css/_variable.scss";
.form-box-wrapper{
    width: 100%;
    margin: auto;
    padding-top: 230px;
    padding-bottom: 120px;

    @media #{$lg} {
        padding-top: 170px;
    }

    @media #{$sm} {
        padding-top: 80px;
        padding-bottom: 80px;
    }
}
</style>